import { Messages } from '../../../../codegen/Localize';
import { ISiteUserInfo } from '../../../../ts/models/ISiteUserInfo';
import { siteUserEditSiteRole } from '../../../actions/spaces/SiteUserMenuActions';
import { SessionUserSelectors } from '../../../selectors/SessionInfoSelectors';
import { AppState } from '../../../state/AppState';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import { areAllSelectedUsersServerAdmins, isSingleSelectSiteUserGuest } from './IEntityActionHelpers';

export const SiteUserSiteRoleAction: IEntityAction<ISiteUserInfo, {}> = {
  name: EntityActionNames.SiteUserSiteRole,
  translateName: Messages.siteRole_action,
  isVisible: (targetItems: ISiteUserInfo[], state: AppState) => {
    return targetItems.length > 0
      && SessionUserSelectors.canManageUsers(state)
      && !isSingleSelectSiteUserGuest(targetItems)
      && (!areAllSelectedUsersServerAdmins(targetItems) || SessionUserSelectors.isSessionServerAdmin(state));
  },
  isClickable: (_availableActions: {}, targetItems: ISiteUserInfo[], state: AppState) => {
    return true;
  },
  createReduxAction: (targetItems: ISiteUserInfo[]) => siteUserEditSiteRole(targetItems)
};
